import { dataQuestionCommentSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQuestionCommentSolid = /*#__PURE__*/createIcon(dataQuestionCommentSolid)
export default IconQuestionCommentSolid
